var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "information--square",
    transform: "translate(-4 -4)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21108",
    "data-name": "Path 21108",
    d: "M15.333,19.333V14H12.667v1.333H14v4H12v1.333h5.333V19.333Z",
    transform: "translate(-2.667 -3.333)",
    fill: "#2162d5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21109",
    "data-name": "Path 21109",
    d: "M15.5,8a1,1,0,1,0,1,1A1,1,0,0,0,15.5,8Z",
    transform: "translate(-3.5 -1.333)",
    fill: "#2162d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21110",
    "data-name": "Path 21110",
    d: "M18.667,20H5.333A1.335,1.335,0,0,1,4,18.667V5.333A1.335,1.335,0,0,1,5.333,4H18.667A1.335,1.335,0,0,1,20,5.333V18.667A1.335,1.335,0,0,1,18.667,20ZM5.333,5.333V18.667H18.667V5.333Z",
    fill: "#2162d5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNewIcon);
export default __webpack_public_path__ + "static/media/InfoNewIcon.dc9fb4bbbc4ae15cb450d4ced5bfc537.svg";
export { ForwardRef as ReactComponent };